import { serviceUUID, characteristicUUID_RX, characteristicUUID_TX } from '../constants';
// No CAN or device knowledge. Uses 20-byte ATT payloads even with the default MTU.
export async function connectBle(onBytes, onDisconnect, onProgress = () => {}) {
  const device = await navigator.bluetooth.requestDevice({filters:[{name:'Sprinter'}],optionalServices:[serviceUUID]});
  let live = true, rx;
  const disconnected = () => { if(live) {live=false;onDisconnect();} };
  device.addEventListener('gattserverdisconnected',disconnected);
  async function step(label, operation) {
    onProgress(label);
    let timer;
    try {
      return await Promise.race([
        Promise.resolve().then(operation).then(value => {
          if (!live) {device.gatt.disconnect();throw new Error('BLE connection ended');}
          return value;
        }),
        new Promise((_, reject) => {timer=setTimeout(() => reject(new Error(`${label} timed out. Try reconnecting; if it persists, toggle phone Bluetooth.`)),15000);}),
      ]);
    } finally {clearTimeout(timer);}
  }
  try {
    const server = await step('Connecting to Sprinter', () => device.gatt.connect());
    const service = await step('Finding gateway service', () => server.getPrimaryService(serviceUUID));
    const tx = await step('Finding notifications', () => service.getCharacteristic(characteristicUUID_TX));
    rx = await step('Finding command channel', () => service.getCharacteristic(characteristicUUID_RX));
    tx.addEventListener('characteristicvaluechanged',event => {
      if(!live)return;
      const value=event.target.value;
      try {onBytes(new Uint8Array(value.buffer,value.byteOffset,value.byteLength));}
      catch(e) {device.gatt.disconnect();disconnected();}
    });
    await step('Enabling notifications', () => tx.startNotifications());
  } catch(e) {device.gatt.disconnect();disconnected();throw e;}
  return {
    async send(bytes) {
      for(let offset=0;offset<bytes.length;offset+=20) {
        if(!live)throw new Error('BLE disconnected');
        const chunk=bytes.slice(offset,offset+20);
        try {await rx.writeValueWithResponse(chunk);}
        catch(e) {device.gatt.disconnect();disconnected();throw e;}
      }
    },
    close() {device.gatt.disconnect();disconnected();},
  };
}
